import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { bMarker, rMarker, gMarker, oMarker } from "./Pins";
import React, { useEffect, useState, useRef } from "react";

const Map = ({ p }) => {
  const [position, setPosition] = useState([44.787197, 20.457273]);
  const [zoom, setZoom] = useState(7);
  const mapRef = useRef(null);

  const checkSameLocation = () => {
    if (p.length === 0) {
      return true;
    }

    const firstPinLocation = p[0].mesto;
    for (let i = 1; i < p.length; i++) {
      if (p[i].mesto !== firstPinLocation) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    setZoom(10);
    if (p.length > 0 && mapRef.current && checkSameLocation()) {
      const latitudes = p.map((pin) => pin.latitude);
      const longitudes = p.map((pin) => pin.longitude);

      const minLatitude = Math.min(...latitudes);
      const maxLatitude = Math.max(...latitudes);
      const minLongitude = Math.min(...longitudes);
      const maxLongitude = Math.max(...longitudes);

      const centerLatitude = (minLatitude + maxLatitude) / 2;
      const centerLongitude = (minLongitude + maxLongitude) / 2;

      mapRef.current.setView([centerLatitude, centerLongitude], 10);
      mapRef.current.flyTo([centerLatitude, centerLongitude], zoom);
    } else if (
      p.length > 0 &&
      mapRef.current &&
      checkSameLocation() === false
    ) {
      mapRef.current.setView(position, 7);
      mapRef.current.flyTo(position, 7);
    }
  }, [p]);
  return (
    <>
      <MapContainer
        ref={mapRef}
        center={position}
        zoom={zoom}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {p.map(
          (
            {
              id,
              latitude,
              longitude,
              mesto,
              direktor,
              e_mail,
              kontakt_lice,
              maticna_ustanova,
              mobil_tel,
              naziv_ustanove,
              okrug,
              opstina,
              pozivni_broj,
              region,
              tel,
              tip_ustanove,
              ulica_broj,
              website,
            },
            index
          ) => (
            <Marker
              icon={
                tip_ustanove === "Позоришта"
                  ? rMarker
                  : tip_ustanove === "Музеји и галерије са фондом "
                  ? gMarker
                  : tip_ustanove === "Библиотеке"
                  ? bMarker
                  : tip_ustanove === "Биоскопи"
                  ? oMarker
                  : ""
              }
              key={id}
              position={[latitude ? latitude : "", longitude ? longitude : ""]}
            >
              <Popup
                position={[
                  latitude ? latitude : "",
                  longitude ? longitude : "",
                ]}
              >
                <div>
                  <table>
                    <thead></thead>
                    <tbody>
                      <tr>
                        <td>Директор:</td>
                        <td>{direktor}</td>
                      </tr>
                      <tr>
                        <td>Мејл:</td>
                        <td> {e_mail}</td>
                      </tr>

                      <tr>
                        <td>Контакт Лице:</td>
                        <td>{kontakt_lice}</td>
                      </tr>
                      <tr>
                        <td>Матична установа:</td>
                        <td>{maticna_ustanova}</td>
                      </tr>
                      <tr>
                        <td>Место:</td>
                        <td>{mesto}</td>
                      </tr>
                      <tr>
                        <td>Мобилни телефон:</td>
                        <td>{mobil_tel}</td>
                      </tr>
                      <tr>
                        <td>Назив установе:</td>
                        <td>{naziv_ustanove}</td>
                      </tr>

                      <tr>
                        <td>Округ:</td>
                        <td>{okrug}</td>
                      </tr>
                      <tr>
                        <td>Општина:</td>
                        <td>{opstina}</td>
                      </tr>
                      <tr>
                        <td>Позивни број:</td>
                        <td>{pozivni_broj}</td>
                      </tr>
                      <tr>
                        <td>Регион:</td>
                        <td>{region}</td>
                      </tr>
                      <tr>
                        <td>Телефон:</td>
                        <td>{tel}</td>
                      </tr>
                      <tr>
                        <td>Тип установе:</td>
                        <td>{tip_ustanove}</td>
                      </tr>
                      <tr>
                        <td>Улица и број:</td>
                        <td>{ulica_broj}</td>
                      </tr>
                      <tr>
                        <td>Вебсајт:</td>
                        <td>{website}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Popup>
            </Marker>
          )
        )}
      </MapContainer>
    </>
  );
};

export default Map;
